import { put, takeLatest, select } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports

import Logger from '@Utils/Logger'

import {
  ISuccessResponse,
} from '@Root/types'

import { IApplicationState } from '@Site/rootReducer'

import {
  getFollowedExportationsSuccess,
} from './actions'

import {
  ExportationActionTypes,
} from './types'

import {
  IGetFollowedExportationsSuccessResponseBody,
} from '@EditorModules/Exportation/types'

import * as API from './api'

const call: any = Eff.call

function* getFollowedExportationsSaga() {
  try {
    const exportationIds: number[] = yield select(
      (state: IApplicationState) => state.exportations.followedExportationIds
    )
    const response: ISuccessResponse<IGetFollowedExportationsSuccessResponseBody> = yield call(API.getFollowedExportations, { exportationIds })
    const payloadResponse = response.data
    yield put(getFollowedExportationsSuccess(payloadResponse))
  } catch(error) {
    Logger.error(error)
  }
}

function* exportationSagas() {
  yield takeLatest(ExportationActionTypes.GET_FOLLOWED_EXPORTATIONS, getFollowedExportationsSaga)
}

export default exportationSagas
